const linksColumns = document.querySelectorAll('.footer-middle__links-column');

if (linksColumns.length) {
    linksColumns.forEach(column => {
        const button = column.querySelector('button');
        const list = column.querySelector('.footer-middle__links-list');

        button.addEventListener('click', () => {
            if (column.classList.contains('-active')) {
                column.classList.remove('-active');
            } else {
                column.classList.add('-active');
            }
        });
    });
}
